import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Button from 'react-bootstrap-button-loader';
import Confirm from 'react-confirm-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setLoader, removeLoader } from '../../../actions';
import { Spinner } from '../../../components/common';
import { SspApi } from '../../../api';
import FormModal from './FeedForm';
import { humanize } from '../../../utils/helpers/text_formatters';

class FeedManager extends Component {
  
  componentDidMount() {
    this.fetchFeeds();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchFeeds();
    }
  }

  fetchFeeds(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.feeds.get(data));  
    }
  }

  newResource() {
    const { dispatch, website } = this.props;
    dispatch(show('FeedFormModal', { 
      heading: 'New Feed',
      formAction: 'Create',
      website
    }));
  }

  handleEdit(c, r) {
    const { dispatch, website } = this.props;

    dispatch(show('FeedFormModal', { 
      feed: r,
      heading: `Editing Feed - ${r.name}`,
      formAction: 'Update',
      website 
    }));
  }

  handleDelete(c) {
    const { dispatch, website } = this.props;
    dispatch(SspApi.actions.feedDelete.post(c, website.uuid, (error, success) => {
      if (success) this.fetchFeeds();
    }));
  }

  handleStatus(r, action) {
    const { dispatch, website, feeds } = this.props;
    
    const args = [r.uuid, website.uuid, { 
      feed: { 
        status: action === 'pause' ? 'paused' : 'pending' 
      } 
    }];

    dispatch(setLoader('FeedStatusUpdate'));
    dispatch(SspApi.actions.feedUpdate.post(...args, (error, success) => {
      dispatch(removeLoader('FeedStatusUpdate'));
      if (success) {
        const collection = [...feeds.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        dispatch({
          type: SspApi.events.feeds.actionSuccess,
          syncing: false, 
          data: { ...feeds, data: collection, meta: { ...feeds.meta } }
        });
      }
    }));
  }

  renderActions(c, r) {
    const { statusLoading } = this.props;
    const action = (['active', 'pending'].includes(r.status)) ? 'pause' : 'resume';
    return (
      <ul className='list-inline'>
        <li>
          <Button 
            bsSize='xsmall'
            bsStyle='success'
            onClick={this.handleEdit.bind(this, c, r)}
          >
            Edit
          </Button>
        </li>
        
        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to delete this?'
            confirmText='Confirm Delete'
            title={`Deleting Feed - ${r.name}`}
          >
            <button className='btn-danger btn btn-xs'>
              Delete
            </button>
          </Confirm>
        </li>
        {(['active', 'pending', 'paused'].includes(r.status)) ? 
          <li>
            <Button 
              type='button' 
              loading={statusLoading} 
              bsStyle={action === 'pause' ? 'warning' : 'success'}
              className='btn-xs'
              onClick={this.handleStatus.bind(this, r, action)}
            >
              {humanize(action)}
            </Button>
          </li> : null}
      </ul>
    );
  }

  render() {
    const { feeds, isLoading } = this.props;
    const { data } = feeds || {};

    const cronDict = {
      '0 */3 * * *': 'Every 3 Hours',
      '0 */6 * * *': 'Every 6 Hours',
      '0 */12 * * *': 'Every 12 Hours',
      '0 */18 * * *': 'Every 18 Hours',
      '1 0 * * *': 'Every Day' 
    };

    return (
      <div>
        <div className='ibox'>
          <div className='ibox-title'>
            <h5>Feeds</h5>      
          </div>
          <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            
            <div className='m-b-sm text-left'>
              <Button 
                bsSize='small' 
                onClick={this.newResource.bind(this)} 
                bsStyle='primary'
              >
                <FontAwesomeIcon icon="plus" /> Add Feed
              </Button>
            </div>

            <BootstrapTable
              striped 
              ref='FeedsTable' 
              data={data || []}
            >
              <TableHeaderColumn 
                width="150"
                dataField="name" 
                dataFormat={(c) => c}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                Name
              </TableHeaderColumn>
              
              <TableHeaderColumn 
                width="150"
                dataField="url" 
                dataFormat={(c) => c}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                URL
              </TableHeaderColumn>

              <TableHeaderColumn 
                width="150"
                dataField="feed_source_name" 
                dataFormat={(c) => c}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                Feed Provider
              </TableHeaderColumn>

              <TableHeaderColumn 
                width="100" 
                dataField="status" 
                dataFormat={(c) => c}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                Status
              </TableHeaderColumn>

              <TableHeaderColumn 
                width="150"
                dataField="cron" 
                dataFormat={(c) => cronDict[c]}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                Index Frequency
              </TableHeaderColumn>

              <TableHeaderColumn 
                isKey
                width="250"
                dataField="uuid" 
                dataFormat={this.renderActions.bind(this)}
                tdStyle={{ whiteSpace: 'normal' }}
                thStyle={{ whiteSpace: 'normal' }}
              >
                Actions
              </TableHeaderColumn>   

            </BootstrapTable>
          </div>
        </div>
        <FormModal />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { ssp, loader } = state;
  return { 
    feeds: ssp.feeds.data, 
    isLoading: ssp.feeds.loading, 
    statusLoading: loader.includes('FeedStatusUpdate') 
  };
};

export default connect(mapStateToProps)(FeedManager);
